export default __webpack_public_path__ + "2d3616cdefc2737ec95a500b27492b3b.png";